import styled from 'styled-components';
import { Table, TableProps } from 'antd';

export interface TableCustomProps<T> extends TableProps<T> {}

export default styled(Table)<TableCustomProps<{}>>`
  .ant-table {
    background: transparent;
    .ant-table-cell {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        height: 24px;
        width: 1px;
        left: 0;
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
    .ant-table-content {
      .ant-table-thead {
        > tr {
          > th {
            background: unset;
            border-bottom: unset;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 18px;
            color: #666666;
            padding: 15px 16px;
            &:before {
              display: none;
            }
          }
          > th.ant-table-selection-column {
            visibility: hidden;
          }
        }
      }
      .ant-table-tbody {
        border-radius: 8px;
        box-shadow: var(--box-shadow);
        .ant-table-row {
          background-color: white;
          cursor: pointer;
          position: relative;
        }
        .ant-table-expanded-row {
          > td {
            background: #ffffff;
          }
        }
        tr {
          td {
            color: #333333;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 21px;
            position: relative;
            padding: 13px 7px 13px 12px;
            &.boder-none::before {
              display: none !important;
            }
            &.ant-table-cell {
              &:before {
                content: '';
                width: 0;
              }
              &.boder-left::before {
                content: '';
                position: absolute;
                height: 50%;
                top: 20%;
                width: 1px !important;
                left: 0;
                background-color: rgba(0, 0, 0, 0.05);
              }
            }
          }
        }
        tr:first-child {
          td:first-child {
            border-top-left-radius: 8px;
          }
          td:last-child {
            border-top-right-radius: 8px;
          }
        }
        tr:last-child td:first-child {
          border-bottom-left-radius: 8px;
        }
        tr:last-child td:last-child {
          border-bottom-right-radius: 8px;
        }
        .ant-table-row-selected td {
          background-color: unset;
        }
        .ant-table-column-sort {
          background-color: unset;
        }
        tr {
          td {
            border-bottom: none;
            position: relative;
            &::after {
              content: '';
              border-bottom: 1px solid #f0f0f0;
              margin: 0 auto;
              position: absolute;
              width: 100%;
              bottom: 0;
              left: 0;
              right: 0;
            }
            &.table-margin:first-child,
            &.table-margin:last-child {
               {
                &:after {
                  margin: unset;
                }
              }
            }
            &:first-child {
              &::after {
                margin-left: 36px;
              }
            }
            &:last-child {
              &::after {
                margin-right: 36px;
              }
            }
          }
        }
      }
      .separate {
        height: 8px;
      }
    }
  }
`;
